import React, { createContext, useContext, useReducer, useEffect } from 'react';
import qs from 'qs';
import { api } from 'api';

const MonitorContext = createContext();

export const useMonitoring = () => useContext(MonitorContext);

export default function MonitorProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  async function loadMonitorList() {
    const data = await api.monitor.loadList();
    if (!data.error) {
      const { v } = qs.parse(window.location.search, { ignoreQueryPrefix: true });
      let selected = null;
      if (v !== undefined) {
        selected = data.find(item => item.monitorId === Number(v));
      }
      if (selected) {
        selectMonitor(selected);
      } else if (data.length > 0) {
        selectMonitor(data[0]);
      }
      dispatch({ type: 'UPDATE_LIST', payload: data });
    }
  }

  function selectMonitor(monitor) {
    dispatch({ type: 'SELECT', payload: monitor });
  }

  useEffect(() => {
    loadMonitorList();
  }, []);

  return (
    <MonitorContext.Provider value={{ ...state, selectMonitor }}>
      {children}
    </MonitorContext.Provider>
  );
}

function reducer(state, { type, payload }) {
  switch (type) {
    case 'UPDATE_LIST':
      return {
        ...state,
        monitors: payload,
        status: 'loaded'
      };
    case 'SELECT':
      return { ...state, selected: payload };
    default:
      return state;
  }
}

const initialState = {
  status: 'loading',
  selected: null,
  monitors: []
};
